import { atom } from 'recoil'

export interface ModalActivateSimulateState {
  mode: 'activate' | 'simulate'
  show: boolean
}

export const modalActivateSimulateState = atom<ModalActivateSimulateState>({
  key: 'workflow_modalActivateSimulateState',
  default: {
    mode: 'simulate',
    show: false
  }
})
